var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClinic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#42ba85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41,42H40V9a2.9,2.9,0,0,0-3-3H30V4a2,2,0,0,0-2-2H20a2,2,0,0,0-2,2V6H11A2.9,2.9,0,0,0,8,9V42H7a2,2,0,0,0,0,4H41a2,2,0,0,0,0-4ZM21,7h2V5a1,1,0,0,1,2,0V7h2a1,1,0,0,1,0,2H25v2a1,1,0,0,1-2,0V9H21a1,1,0,0,1,0-2Zm-5,9h6v6H16Zm0,9h6v6H16ZM27,42H21V35h6Zm5-11H26V25h6Zm0-9H26V16h6Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinic);
export default __webpack_public_path__ + "static/media/clinic.e484fb43793f14f88d26ee2aef31cebf.svg";
export { ForwardRef as ReactComponent };